import { render, staticRenderFns } from "./h5ConsumerList.vue?vue&type=template&id=0edf6e24&scoped=true"
import script from "./h5ConsumerList.vue?vue&type=script&lang=js"
export * from "./h5ConsumerList.vue?vue&type=script&lang=js"
import style0 from "./h5ConsumerList.vue?vue&type=style&index=0&id=0edf6e24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf6e24",
  null
  
)

export default component.exports